import {
  CustomStatusesMap,
  Role,
  StatusWorkflow,
  Team,
  User
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
}

interface ResponseDataType {
  is_company_can_enable_more_templates_available_in_offline: boolean;
  roles: Role[];
  users: User[];
  teams: Team[];
  status_workflows: StatusWorkflow[];
  custom_statuses_map: CustomStatusesMap;
}

export const getCustomFormSettingsDataRequest = ({ token }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest('/custom-form-template/form-settings-data', {
    token,
  });
};